import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { ref, computed, watch } from 'vue';

interface Props {
  data: { [key: string]: string }[];
  label?: string;
  showLabel?: boolean;
  labelWidth?: number;
  labelAlign?: 'right' | 'center' | 'left';
  labelPosition?: 'left' | 'top';
  labelSize?: string;
  labelColor?: string;
  labelClass?: string;
  scrollHeight?: string | number;
  required?: boolean;
  border?: boolean;
  field?: { id: string; name: string };
  only?: any;
  change?: (payload: Record<string, any> | null) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: /*@__PURE__*/_mergeModels({
    data: { default: () => [] },
    label: { default: '标题' },
    showLabel: { type: Boolean, default: true },
    labelWidth: { default: 120 },
    labelAlign: { default: 'left' },
    labelPosition: { default: 'left' },
    labelSize: { default: 'text-size-30' },
    labelColor: { default: '#000' },
    labelClass: { default: '' },
    scrollHeight: { default: 50 },
    required: { type: Boolean, default: true },
    border: { type: Boolean, default: true },
    field: { default: () => ({ id: 'id', name: 'name' }) },
    only: {},
    change: {}
  }, {
    "value": {},
    "valueModifiers": {},
    "text": {},
    "textModifiers": {},
  }),
  emits: ["update:value", "update:text"],
  setup(__props: any) {

const value = _useModel<string>(__props, 'value');
const text = _useModel<string>(__props, 'text');
const props = __props;

const themeVars = ref({
  radioLabelFontActiveColor: '#165dff',
  radioLabelFontSize: '14px',
  'icon-height': '20px',
});
const isClick = ref(false);

// 设置 label 宽度
const setLabelWidth = computed(() =>
  props.labelPosition === 'left' ? `${props.labelWidth}px` : '100%'
);

// 设置 label 对齐方式
const setLabelAlign = computed(() =>
  props.labelPosition === 'left' ? `text-${props.labelAlign}` : 'text-left'
);

// 设置 scroll-view 高度
const setScrollHeight = computed(() =>
  props.labelPosition === 'left' ? `${props.scrollHeight}px` : 'auto'
);

// 设置 label高度
const setLabelHeight = computed(() =>
  props.labelPosition === 'top' ? `${props.scrollHeight}px` : 'auto'
);

// 处理选项改变
const handleChange = (id: string) => {
  const selectedItem = props.data.find(item => item[props.field.id] === id);
  text.value = selectedItem?.[props.field.name] || '';
  if (typeof props.change === 'function') {
    props?.change({
      id,
      ...selectedItem,
      isClick: isClick.value,
      _isClick: isClick.value,
      only: props.only,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_nut_radio = _resolveComponent("nut-radio")!
  const _component_nut_radio_group = _resolveComponent("nut-radio-group")!
  const _component_nut_config_provider = _resolveComponent("nut-config-provider")!
  const _component_nut_skeleton = _resolveComponent("nut-skeleton")!
  const _component_taro_scroll_view = _resolveComponent("taro-scroll-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["items-center scroll-form-radio", {
      block: props.labelPosition === 'top',
      flex: props.labelPosition === 'left',

      'py-[10px]': props.labelPosition === 'top',
    }]),
    style: _normalizeStyle({
      height: setScrollHeight.value,
      borderBottom: props.border ? '1px solid #e5e5e5' : 'none',
    })
  }, [
    (_ctx.showLabel)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`${_ctx.labelSize} ${setLabelAlign.value} ${_ctx.labelClass} scroll-form-radio-label `),
          style: _normalizeStyle({
        width: setLabelWidth.value,
        minWidth: setLabelWidth.value,
        height: setLabelHeight.value,
        color: props.labelColor,
      })
        }, _toDisplayString(props.label), 7))
      : _createCommentVNode("", true),
    _createVNode(_component_taro_scroll_view, {
      enablePassive: "",
      enhanced: "",
      class: "flex items-center",
      refresherTwoLevelEnabled: true,
      refresherTwoLevelTriggered: true,
      "scroll-y": false,
      "scroll-x": true,
      showScrollbar: "",
      scrollWithAnimation: ""
    }, {
      default: _withCtx(() => [
        (props.data?.length)
          ? (_openBlock(), _createBlock(_component_nut_config_provider, {
              key: 0,
              "theme-vars": themeVars.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_nut_radio_group, {
                  modelValue: value.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
                  direction: "horizontal",
                  class: "flex-important",
                  onChange: handleChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item) => {
                      return (_openBlock(), _createBlock(_component_nut_radio, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (isClick.value = true)),
                        label: item[props.field.id],
                        key: item[props.field.id]
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item[props.field.name]), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["theme-vars"]))
          : (_openBlock(), _createBlock(_component_nut_skeleton, {
              key: 1,
              width: "300px",
              animated: ""
            }))
      ]),
      _: 1
    })
  ], 6))
}
}

})